// A build, from the lead's desk: the same view the floor has, and "Write
// instructions" for its assembly revision (L3).
import { useNavigate, useParams } from 'react-router';

import { useOpenInstructions } from '../../api/queries';
import { canBuild, useSession } from '../../auth/session';
import { Button, ErrorPanel } from '../../design/components';
import { BuildPage } from '../build/BuildPage';

export function LeadBuildPage() {
    const { buildId = '' } = useParams();
    const session = useSession();
    const navigate = useNavigate();
    const open = useOpenInstructions();
    return (
        <div className="sf-stack">
            {canBuild(session) ? (
                <div className="sf-row sf-no-print">
                    <Button
                        disabled={open.isPending}
                        onClick={() => {
                            open.mutate(buildId, {
                                onSuccess: (opened) => {
                                    void navigate(`/lead/instructions/${opened.instructionSetId}`);
                                },
                            });
                        }}
                    >
                        Write instructions for this revision
                    </Button>
                    {open.isError ? <ErrorPanel error={open.error} /> : null}
                </div>
            ) : null}
            <BuildPage />
        </div>
    );
}
